import { Upload } from 'antd';
import type { UploadProps } from 'antd';
import { forwardRef } from 'react';
import { CONTROL_CLASS } from '@/theme/controlSizing';

/**
 * Props {@link UploadBox}. Inherits `UploadProps` Antd.
 */
export type UploadBoxProps = UploadProps;

/**
 * Upload — wrapper Antd Upload.
 *
 * Antd Upload tidak punya `size` prop atau `controlHeight` — tinggi mengikuti
 * children-nya (biasanya Button). Class `booku-control` dipasang untuk
 * konsistensi (jika di kemudian hari ada CSS rule khusus).
 *
 * Pemakaian:
 * ```tsx
 * <UploadBox
 *   beforeUpload={(file) => { handleFile(file); return false; }}
 *   accept=".csv,.xlsx"
 *   showUploadList={false}
 * >
 *   <Button icon={<UploadOutlined />}>Pilih File</Button>
 * </UploadBox>
 * ```
 *
 * Dokumentasi pattern: `.claude/docs/Booku v2/ui-patterns/control-system-pattern.md`
 */
export const UploadBox = forwardRef<HTMLSpanElement, UploadBoxProps>(
  function UploadBox({ className, ...rest }, ref) {
    return (
      <Upload
        ref={ref as never}
        className={`${CONTROL_CLASS}${className ? ` ${className}` : ''}`}
        {...rest}
      />
    );
  }
);

// Re-export Upload.Dragger untuk varian drag-and-drop.
export const UploadDragger = Upload.Dragger;
